import ProjectionAssignation from "./ProjectionAssignation";

export default class ProjectData {
  projectName: string;
  assignations: ProjectionAssignation[];

  constructor(projectName: string, assignations: ProjectionAssignation[]) {
    this.projectName = projectName;
    this.assignations = assignations;
  }

  public updateAssignationData(externalId: string, roleType?: string, hours?: number) {
    if (roleType) {
      this.assignations.find((a) => a.externalId === externalId)!.roleType = roleType;
    }

    if (hours) {
      this.assignations.find((a) => a.externalId === externalId)!.externalHours = hours;
    }
  }
}
